import { Tabs, Select } from 'antd';
import styles from "./callsShareFile.module.scss";
import { URButton } from '../../../../shared/widgets/button';
import { URRadio } from '../../../../shared/widgets/radiobox';
import React, { useState } from "react";
import taskimg2 from "../../../../styles/images/task2.svg";
import { useSelector } from 'react-redux';
import { callMainPageInterface } from '../../../../models/callModel';
import _ from 'lodash';
import {
  callActionChanges, DataURIToBlob, searchHandler, toastInformation, wordSharenDownnload
} from '../../../../base/callService/common';
import store from '../../../../context/store/store';
import MemberLists from '../memberList';
import { fileUploadnShareCall } from '../../../../base/socketChatService/utils';
import jsPDF from 'jspdf';
const { TabPane } = Tabs;

type ChatShareFileState = {
  radioKey: string;
  allContacts:Array<any>;
  tempAllContacts:Array<any>;
  selectedContacts: Array<any>;
  blobUrl:any;
  radioKeyMail: string;
  currentTabKey: string;
  searchText: string;
};

export default function ChatShareFile() {
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  let { workContacts } = contactReducer;

  let workList = contactReducer.workContacts;
  let teamList:Array<any> = contactReducer.teamContacs;
  let searchableContact: Array<any> = workList.concat(teamList);

  const [shareFileState, setShareFileState] = useState<ChatShareFileState>
  ({
    radioKey: '',
    allContacts:workContacts,tempAllContacts:workContacts,
    selectedContacts: [],blobUrl:"",
    radioKeyMail:'',currentTabKey:'1',searchText:''
  });
  let { radioKey, allContacts, selectedContacts,
    radioKeyMail, currentTabKey,searchText } = shareFileState;
  
  const radioChecked = async(type: string,isDownload:boolean) => {
    if (type === 'pdf') {
      toastInformation('Generating PDF file. Please wait', 'alert');

  let { quilDiv } = store.getState().closeCaption || {};
  var source: any;
    let bodyText = '';
    let text=quilDiv;
    bodyText +=
        '<div style=" margin-left: 40px;font-size: 11px;color: #4B5563;line-height: 17px;position: relative;">'
        +text + '</div>';

        source =  bodyText;
        var doc = new jsPDF({
          orientation: 'portrait',
          unit: 'pt'
        });
      const result = await doc.html(source, {
          margin:[40,100,100,60],
          callback: async function(doc: any) {
                      
           
      let pdfurl: string = doc.output("dataurlstring");
      let basepdfurl:any =  pdfurl.replace('data:application/pdf;filename=generated.pdf;base64,', '')+  encodeURIComponent(source) ;
      let downloadUrl = await DataURIToBlob(pdfurl);
    if (isDownload) {
        let filename = 'conference.pdf';
        let downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = pdfurl;
        downloadLink.download = filename;
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
            setShareFileState({...shareFileState, blobUrl:downloadUrl ,radioKey:'pdf'});
            
    }      
  });
       }
    else if (type === 'doc') { textToWord(isDownload); }
    else  {  setShareFileState({ ...shareFileState,radioKeyMail:type }); }
  };
  
  const internalShare = () => {
    if (selectedContacts.length < 1) return toastInformation("No contact selected", 'warning');
    let closedCaption: any = store.getState().closeCaption;
    let fileName: string = closedCaption.shareFrom === "MOM" ? 'Automated Minutes' : 'Transcription';
    fileUploadnShareCall(shareFileState.blobUrl,selectedContacts,(`${fileName}.${radioKey}`));
    callActionChanges("summaryShare");
    toastInformation(`${fileName} shared successfully`, 'success');
  };

  const externalShare = () => {
    if (radioKeyMail==='') return toastInformation("Please select share type", 'warning');
    if(radioKey!=='') {
      if (radioKeyMail === 'gmail') {
        window.open('https://mail.google.com/mail/u/0/?fs=1&to=&su=Auto summary from Unified ring&body=&bcc=&tf=cm');
      }
      else { window.open('mailto:'); }
      callActionChanges("summaryShare");
    }
  };

  const searchContact = _.debounce(async(e: any) => {
    let searchName = e.toLowerCase();
    if(searchName !== "") {
 
      setShareFileState({
        ...shareFileState,
        allContacts: searchHandler(searchableContact, searchName), searchText: searchName
      });
    }
    else{
      if(searchName === "") {
        setShareFileState({...shareFileState,allContacts:searchableContact,searchText:''});
      }
    }
  }, 500);

  const change = (val:any,obj:any) =>{
    setShareFileState({...shareFileState,selectedContacts:val,
      allContacts:searchableContact});
  };

  const textToWord = async(isDownload: boolean) => {
    let wordBlob = await wordSharenDownnload(isDownload);
    setShareFileState({...shareFileState,radioKey:'doc',blobUrl:wordBlob});
  };

  const handleCancel =()=>{
    setShareFileState({ ...shareFileState, selectedContacts: [], radioKey: '' ,searchText:''});
    callActionChanges("summaryShare");
  };
  const handleTab = (key:string) => {
    setShareFileState({...shareFileState,radioKey:'',radioKeyMail:'',currentTabKey:key});
  };
  return (
    <>
      <div className={styles.chatDialPadContainer}>
        <div className={styles.chatsharefile}>
          <div className={styles.topHeaderShareSec}>
            <h4>Share Transcription</h4>
          </div>
          <div className={styles.topinnerSecCon}>
            <Tabs defaultActiveKey="1" centered className="TopNavBtn" onChange={handleTab}>
              <TabPane tab="Contact Book" key="1">
                <div className={styles.shareFileConSecScroll}>
                  <div className={styles.formGrouprow}>
                    <h4>Contacts</h4>
                    <div className={styles.shareSelect}>
                      <div className={styles.insideicon}>
                        <img src={taskimg2} alt="" />
                        <Select
                          mode="multiple"
                          style={{ width: '100%' }}
                          placeholder="No Assignee"
                          className="newselects taskcreations"
                          showSearch={true}
                          filterOption={false}
                          value={selectedContacts}
                          onChange={change}
                          onSearch={searchContact}>
                          {MemberLists(searchText , allContacts)}

                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className={styles.formGrouprow}>
                    <h4>File format</h4>
                    <div className={styles.radiospacealign}>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKey==='pdf'} onChange={()=>radioChecked('pdf',false)}/> <span>PDF</span>
                      </div>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKey === 'doc'} onChange={() => radioChecked('doc', false)} />
                        <span>Word</span>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tab="External" key="2" className="TopNavBtn">
                <div className={styles.shareFileConSecScroll}>
                  <div className={styles.formGrouprow}>
                    <h4>Mail</h4>
                    <div className={styles.radiospacealign}>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKeyMail === 'gmail'} onChange={() => radioChecked('gmail', true)} />
                        <span>Gmail</span>
                      </div>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKeyMail === 'outlook'} onChange={() => radioChecked('outlook', true)} />
                        <span>Outlook</span>
                      </div>
                    </div>
                  </div>
                  <div className={styles.formGrouprow}>
                    <h4>File format</h4>
                    <div className={styles.radiospacealign}>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKey==='pdf'} onChange={()=>radioChecked('pdf',true)}/> <span>PDF</span>
                      </div>
                      <div className={styles.widthsmall}>
                        <URRadio checked={radioKey === 'doc'} onChange={() => radioChecked('doc', true)} />
                        <span>Word</span>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
          <div className={styles.chatfooterbtn}>
            <URButton className={styles.chatcancelbtn} name='Cancel' onClick={handleCancel} />
            {currentTabKey === '1' ?
              <URButton className={radioKey!=='' ? styles.chatSharebtn : styles.chatSharebtnDisable} name='Share'
                onClick={internalShare} /> :
              <URButton className={radioKey !== '' || radioKeyMail !== '' ?
                styles.chatSharebtn : styles.chatSharebtnDisable} name='Share'
              onClick={ externalShare} />}
          </div>
        </div>
      </div>
    </>
  );
};

